module.exports = __webpack_public_path__ + "img/03.66c7c2e9.png";